import * as React from 'react';
import { ModalBody, ModalBodyProps } from 'reactstrap';

import { ErrorView } from '@app/Components/ErrorView/ErrorView';

type ErrorBoundaryState = {
    hasError: boolean;
    error: Error | null;
    componentStack: string | null;
};

class ModalBodyWithBoundary extends React.Component<ModalBodyProps, ErrorBoundaryState> {

    constructor(props: ModalBodyProps) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            componentStack: null
        };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        this.setState({
            hasError: true,
            error: error,
            componentStack: errorInfo.componentStack || null
        });
    }

    render() {
        if (this.state.hasError) {
            return <ErrorView error={this.state.error} componentStack={this.state.componentStack} isInDialog />;
        }
        return (<ModalBody {...this.props}>{this.props.children}</ModalBody>);
    }
}

export default ModalBodyWithBoundary;
